import type { SearchOption } from '@/components/ui/SearchSelect';
export interface FieldDraft {
  title: string;
  date: string;
  from: string;
  to: string;
  amount: string;
  currency: string;
  owner: string | null;
  tags: string[];
  pendingTag: string;
}
export const FIELD_HOME = '/design/fields';
export const OPTIONS: SearchOption[] = Array.from({ length: 240 }, (_, i) => ({
  value: 'team-' + (i + 1),
  label:
    'Команда ' +
    String(i + 1).padStart(3, '0') +
    ' · ' +
    ['Северный контур', 'Лаборатория', 'Мастерская', 'Южный контур'][i % 4],
  description: i % 37 === 36 ? 'Временно недоступна' : 'Рабочая группа · образец',
  disabled: i % 37 === 36,
}));
export const initialDraft = (id: string): FieldDraft => ({
  title: id === 'a' ? 'Плановая проверка' : 'Подготовка площадки',
  date: '28.10.2026',
  from: '28.10.2026',
  to: '30.10.2026',
  amount: id === 'a' ? '18 750,00' : '6 400,00',
  currency: 'RUB',
  owner: id === 'a' ? 'team-12' : 'team-80',
  tags: ['Планирование', 'Осень'],
  pendingTag: '',
});
export function decodeDraft(value: unknown): FieldDraft {
  if (!value || typeof value !== 'object' || Array.isArray(value)) throw new Error('shape');
  const v = value as Record<string, unknown>;
  const text = (key: string, max: number) => {
    const s = v[key];
    if (typeof s !== 'string' || s.length > max) throw new Error('text');
    return s;
  };
  const currency = text('currency', 3);
  if (!['RUB', 'USD', 'JPY', 'KWD'].includes(currency)) throw new Error('currency');
  if (v.owner !== null && (typeof v.owner !== 'string' || v.owner.length > 80)) throw new Error('owner');
  if (
    !Array.isArray(v.tags) ||
    v.tags.length > 8 ||
    v.tags.some((t) => typeof t !== 'string' || !t.trim() || t.length > 40)
  )
    throw new Error('tags');
  return {
    title: text('title', 120),
    date: text('date', 10),
    from: text('from', 10),
    to: text('to', 10),
    amount: text('amount', 64),
    currency,
    owner: v.owner as string | null,
    tags: [...v.tags] as string[],
    pendingTag: text('pendingTag', 512),
  };
}
